export const DROPOFF_JSON = {
  "appform-details": {
    frstNm: "",
    preferred_identity_proof: "",
    preferred_age_proof: "",
    lstNm: "",
    mrtlSts: "",
    education: "",
    occ: "",
    occDesc: "",
    nameOfOrg: "",
    orgType: "",
    orgTypeDesc: "",
    myProfession: "",
    orgNameDesc: "",
    panNo: "",
    annIncme: "",
    politically_exposed_person: "No",
    criminal_offence: "No",
    investigationDtls: "",
    isThirdPartyPayment: "No",
    iibSection: "",
    iibApiStatus: "",
    iibSectionData: [],
    iibPolicies: [],
  },
  Nominee: {
    marriedProtectAct: "No",
    bene_fname1: "",
    bene_lname1: "",
    bene_dob1: "",
    bene_reln1: "",
    bene_share1: "",
    bene_fname2: "",
    bene_lname2: "",
    bene_dob2: "",
    bene_reln2: "",
    bene_share2: "",
    bene_fname3: "",
    bene_lname3: "",
    bene_dob3: "",
    bene_reln3: "",
    bene_share3: "",
    bene_fname4: "",
    bene_lname4: "",
    bene_dob4: "",
    bene_reln4: "",
    bene_share4: "",
    bene_fname5: "",
    bene_lname5: "",
    bene_dob5: "",
    bene_reln5: "",
    bene_share5: "",
    bene_fname6: "",
    bene_lname6: "",
    bene_dob6: "",
    bene_reln6: "",
    bene_share6: "",
    trust_type1: "",
    trust_name1: "",
    trust_address1: "",
    trust_city1: "",
    trust_state1: "",
    trust_dob1: "",
    trust_pincode1: "",
    trust_type2: "",
    trust_name2: "",
    trust_address2: "",
    trust_city2: "",
    trust_state2: "",
    trust_dob2: "",
    trust_pincode2: "",
    trust_type3: "",
    trust_name3: "",
    trust_address3: "",
    trust_city3: "",
    trust_state3: "",
    trust_dob3: "",
    trust_pincode3: "",
    trust_type4: "",
    trust_name4: "",
    trust_address4: "",
    trust_city4: "",
    trust_state4: "",
    trust_dob4: "",
    trust_pincode4: "",
    trust_type5: "",
    trust_name5: "",
    trust_address5: "",
    trust_city5: "",
    trust_state5: "",
    trust_dob5: "",
    trust_pincode5: "",
    trust_type6: "",
    trust_name6: "",
    trust_address6: "",
    trust_city6: "",
    trust_state6: "",
    trust_dob6: "",
    trust_pincode6: "",
    add_trust1: "",
    add_trust2: "",
    add_trust3: "",
    add_trust4: "",
    add_trust5: "",
    add_bene1: "",
    add_bene2: "",
    add_bene3: "",
    add_bene4: "",
    add_bene5: "",
    nomineefrstNm: "",
    nomineelstNm: "",
    nomineeGender: "",
    relationship: "",
    nomineeDob: "",
    appointeefrstNm: "",
    appointeelstNm: "",
    appointeeGender: "",
    appointeeRelationship: "",
    appointeeDob: "",
    isEIAOpted: "No",
    EIAAccountNumber: "",
    eiaInsuranceRepository: "Not Interested",
    insuranceInfos: "",
    cmpany1: "",
    sum1: "",
    cmpany2: "",
    sum2: "",
    cmpany3: "",
    sum3: "",
    cmpany4: "",
    sum4: "",
    cmpany5: "",
    sum5: "",
    dependentInsuranceInfos: "",
    deInCmpany1: "",
    deSum1: "",
    deIncome1: "",
    deInCmpany2: "",
    deSum2: "",
    deIncome2: "",
    deInCmpany3: "",
    deSum3: "",
    deIncome3: "",
    deInCmpany4: "",
    deSum4: "",
    deIncome4: "",
    deInCmpany5: "",
    deSum5: "",
    deIncome5: "",
    trust_pancard1: "",
    reasonNonBloodRelation: "",
    otherReasonForNonBloodRelation: "",
    relationshipOthers: "",
    trusteeaccounttype: "",
    trusteeBankAccountNumber: "",
    trusteeBankName: "",
    trusteeIFSC: "",
    trusteeMICR: "",
    trusteeNameofBankAccountHolder: "",
  },
  Communication: {
    address1: "",
    preferred_address_proof: "",
    address2: "",
    address3: "",
    landmark: "",
    pinCode: "",
    city: "",
    state: "",
    country: "India",
    addCommunication: "",
    prmnt_address1: "",
    prmnt_address2: "",
    prmnt_address3: "",
    prmnt_landmark: "",
    prmnt_pinCode: "",
    prmnt_city: "",
    prmnt_state: "",
    prmnt_country: "India",
    mobileNumber: "",
    emailAddress: "",
  },
  Health: {
    HQ07: "",
    HQ05: "",
    tobacco_consumedAs: "",
    tobacco_quantity: "",
    tobacco_years: "",
    HQ06: "",
    alcohol_consumedAs: "",
    alcohol_quantity: "",
    alcohol_years: "",
    HQ125: "",
    HQ09: "",
    weight: "",
    HQ01: "",
    height_cm: "",
    HQ167_All_Fields: "",
    diagnosed_bp: "",
    diagnosed_hk: "",
    diagnosed_hsurgery: "",
    diagnosed_diabetes: "",
    diagnosed_resp: "",
    diagnosed_stroke: "",
    diagnosed_gastro: "",
    diagnosed_liver: "",
    diagnosed_kidney: "",
    diagnosed_cancer: "",
    diagnosed_hiv: "",
    diagnosed_blood: "",
    diagnosed_other: "",
    HQ21: "",
    HQ165: "",
    HQ166: "",
    HQ24: "",
    HQ168: "",
    HQ61: "",
    pregnancyWeeks: "",
    HQ144: "",
    remarks: "",
    HQ188_All: "",
    healthDec: "No",
    healthDec_medicalCondt: "",
    healthDec_diagnosis: "",
    healthDec_duration: "",
    healthDec_currentState: "",
    healthDec_details: "",
    healthDec_treatment: "",
    healthDec_otherDetails: "",
  },
  productSelection: {
    CIBenefit: "",
    CIterm: "",
    ADHB: "",
    ADHBterm: "",
    LifeCoverOption: "",
    policyCommencementDate: "",
    premiumPayingFrequency: "",
    payoutTerm: "",
    policyTerm: "",
    premiumPayingTerm: "",
    sumAssured: "",
    salesChannel: "",
    productType: "TRADITIONAL",
    productName: "ICICI Life iProtect Smart",
    productId: "T51",
    premiumpaymentoption: "",
    option: "",
    lumpsumPercentage: "",
    age: "",
    dob: "",
    gender: "Male",
    useTobacco: "",
    MobileNo: "",
    EmailId: "",
    AnnualIncome: "",
    premium: "",
    annualpremium: "",
    totalPremium: "",
    modalPremium: "",
    traiFlag: "",
    dependentFlag: "N",
    clientId: "",
    isStaff: "",
    relations: "",
    calc_plan: "",
    budget_prem_inp: "",
    altMobileNo: "",
    employeeId: "",
    plantype: "SmartExit:NotOpted",
    occupation: "",
  },
  "kyc-waveoff": {
    addressproof: "",
    idproof: "",
    ageProof: "",
  },
  experianPartnerPO: {
    experianValueFlag: "N",
    filler6: "",
    score: "",
    creditCardLimit: "",
    incomeEstimate: "",
    defaulter: "",
    loanLimit: "",
    source: "",
  },
  "existingCust-details": {
    frstNm: "",
    lstNm: "",
    dob: "",
    panNo: "",
    address1: "",
    address2: "",
    address3: "",
    landmark: "",
    pinCode: "",
    city: "",
    state: "",
    flag: "",
    dummy: "",
    dummy2: "",
    dummy3: "",
    addressproofShortDescription: "",
    ageProofShortDescription: "",
    idproofShortDescription: "",
  },
  appNO: "",
  emailAddress: "",
  UID: 480,
  sourceURL: "",
  Pan_validation_status: "",
  lastQuetionAns: "ekycpage",
  lastQuetionState: "new",
  lastSection: "personal",
  OCRselected: "No",
  ExistingCustomer: "No",
  Perfios: "No",
  language: "english",
  whatsapp_optin: "",
  ExistingCust_Pasa: "No",
  ALM_CRTD_BY: "abcd",
  ckycNumber: "",
  city_list: [],
  CkycJson: {
    CKYCflag: "N",
    Is_edit: null,
    POA: null,
    Consent_timestamp: null,
    BadRequest_Reason: "",
    response: {
      CKYCFullName: "",
      CKYCPerAddPOA: "",
      CKYCPerAdd1: "",
      CKYCPerAdd2: "",
      CKYCPerAdd3: "",
      CKYCPerAddCity: "",
      CKYCPerAddDistrict: "",
      CKYCPerAddState: "",
      CKYCPerAddCountry: "",
      CKYCPerAddPin: "",
      CKYCCorAdd1: "",
      CKYCCorAdd2: "",
      CKYCCorAdd3: "",
      CKYCCorAddCity: "",
      CKYCCorAddDistrict: "",
      CKYCCorAddState: "",
      CKYCCorAddCountry: "",
      CKYCCorAddPin: "",
    },
  },
  ckyctemp: {
    preferred_address_proof: "",
    addCommunication: "",
    Onlyprmnt_add: false,
  },
  Ekyc: {
    EKYC_flag: false,
    Ekyc_BackQuote: false,
    Onlyprmnt_add: true,
    EKYC_Aadhar: "",
    EKYC_Btn_Flag: false,
    EKYC_Otp: "",
    response: {
      name: "",
      gender: "Male",
      dob: "",
      line1: "",
      line2: "",
      line3: "",
      landmark: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      EKYCtoken: "",
    },
  },
  flag_partner: false,
};

export const DEFAULT_NRI_TRAVEL = {
  nriTravelDetails: [
    {
      nameOfCountry: "",
      city: "",
      arrivalDate: "",
      departureDate: "",
      visaType: "",
      purposeOfTravel: "",
      typeOfResidence: "",
    },
  ],
  modeOfTravel: "",
  natureOfBusiness: "",
  safetyPrecaution: "",
};

export const DEFAULT_NRI = {
  passportNo: "",
  lddIdExpiryDate: "",
  dateOfArrivingIndia: "",
  dateOfLeavingIndia: "",
  durationOfStayInYear: "",
  durationOfStayInMonth: "",
  nameOfEmployer: "",
  travelDetails: "",
  bankType: "",
  currentresidence: "",
  countryOfResidence: "",
  nriTINIssuingCountry: "India",
  tinNum: "",
  tinNum2: "",
  tinNum3: "",
  nriBirthCountry: "",
  placeOfBirthNRI: "",
  countryOfResidence2: "",
  countryOfResidence3: "",
  nriOtherResCountry: "",
  countryOfNationality: "",
  nriTaxResidentUS: "No",
  intentedDurationStayInYear: "",
  intentedDurationStay: "",
  purposeOfStay: "",
};
